import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

interface RgpdWarningModalProps {
  show: boolean;
  allowUnsubscribe: boolean;
  onClose: () => void;
  onToggle: (checked: boolean) => void;
}

const RgpdWarningModal: React.FC<RgpdWarningModalProps> = ({
  show,
  allowUnsubscribe,
  onClose,
  onToggle,
}) => {
  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon
            icon={faExclamationTriangle}
            className="me-2"
            style={{ color: "#eb8635" }}
          />
          Avertissement RGPD
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p style={{ fontSize: "18px" }}>
          Permettre le désabonnement peut contrevenir aux règles du RGPD et
          entraîner des répercussions juridiques.
        </p>

        <div className="d-flex align-items-center border rounded p-2 mt-3">
          <input
            className="form-check-input me-2"
            type="checkbox"
            checked={allowUnsubscribe}
            onChange={(e) => onToggle(e.target.checked)}
          />
          <label className="form-check-label mb-0">
            Permettre le désabonnement
          </label>
        </div>

        <div className="mt-3">
          <a
            href="https://annonce-legale-officielle.fr/politique-de-protection/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "underline", color: "#4BB0C0" }}
          >
            Politique de protection des données et Newsletters
          </a>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RgpdWarningModal;
